const mockArchive = [
  {
    id: 428,
    status: 1,
    approved: 1,
    title:
      "สุริยะ ซัดกลับ ฝ่ายค้าน จินตนาการเอง แลนด์บริดจ์ ไร้นักลงทุนสนใจ มั่นใจ เกิดแน่",
    description:
      "‘สุริยะ’ ซัด ฝ่ายค้าน จินตนาการ เหตุ ไม่เห็นภาพนักลงทุนสนใจอื้อ มั่นใจ โครงการเกิดชัวร์ ลั่น พร้อมเยียวยา ปชช. กระทบจาก ‘แลนด์บริดจ์’ โว เดินหน้าสร้างงานกว่า 2 แสนคน ดันจีดีพี พุ่ง 5.5-6%\n\nเมื่อเวลา 11.30 น. วันที่ 22 ม.ค.67 ที่กรมทางหลวงชนบทชุมพร จ.ชุมพร นายสุริยะ จึงรุ่งเรืองกิจ รมว.คมนาคม เป็นประธานการประชุมร่วมกับหน่วยงานที่เกี่ยวข้อง เพื่อติดตามความคืบหน้าและรับฟังการบรรยายสรุปโครงการดำเนินงานของหน่วยงาน โครงการแลนด์บริดจ์ MR8 จ.ระนอง, โครงการแนวเส้นทางเลียบชายฝั่งทะเลอันดามัน ระนอง-สตูล\n\nนายสุริยะให้สัมภาษณ์ถึงความคุ้มค่าในการลงทุน เนื่องจากตัวเลขการคาดการณ์ตู้คอนเทนเนอร์ ที่จะเข้ามาใช้บริการในโครงการแลนด์บริดจ์ ระหว่างสำนักงานนโยบายและแผนการขนส่งและจราจร (สนข.) กับของสำนักงานสภาการพัฒนาเศรษฐกิจและสังคมแห่งชาติ (สศช.) ต่างกัน\n\nนายสุริยะกล่าวว่า สมัยรัฐบาลนายทักษิณ ชินวัตร อดีตนายกรัฐมนตรี เมื่อปี 2545 มีแนวคิดเรื่องการสร้างสนามบินสุวรรณภูมิ ปี 2545 เมื่อก่อสร้างแล้วเสร็จทำให้ประเทศไทย เป็นศูนย์กลางการบินของภูมิภาค ผ่านมา 20 ปี ไม่มีโครงการใหญ่แบบนี้ ทั้งที่ควรมีมาเพิ่มขีดความสามารถของประเทศ จนมาถึง รัฐบาลนายเศรษฐา ทวีสิน มีวิสัยทัศน์ เรื่องโครงการแลนด์บริดจ์ ที่ สนข.ศึกษาตัวเลขและผลตอบแทนความคุ้มค่า โดยรัฐบาลจะลงทุนเรื่องเวนคืนที่ ส่วนการลงทุนอื่น เช่น การสร้างถนน ท่าเรือ รถไฟ จะเป็นของภาคเอกชน\n\nถ้านักลงทุนไม่เชื่อ ก็ไม่มาลงทุน แต่ขณะนี้จากการเดินทางไปต่างประเทศของนายกฯ พูดคุยบนหลายเวที ทั้งการประชุมเอเปค และเวิลด์ อีโคโนมิก ฟอรั่ม ได้พบกับนักลงทุนใหญ่ ให้ความสนใจจำนวนมาก และล่าสุดผู้บริหาร DP WORLD ผู้บริหารพอร์ทดูไบ จะเดินทางมาประเทศไทยในเดือน ก.พ.นี้ เพื่อลงพื้นที่โครงการ ขณะที่มหาเศรษฐีอินเดียก็ให้ความสนใจเป็นอย่างมาก\n\nทั้งนี้ การดำเนินโครงการต้องศึกษาผลกระทบเรื่องสิ่งแวดล้อม และให้ประชาชนเข้ามามีส่วนร่วมและดูแลผลกระทบต่างๆ หากเรื่องไหนแก้ไขได้ ให้ดำเนินการ พร้อมกับอธิบายสิ่งที่ประชาชนให้เข้าใจ เมื่อเข้าใจจะเดินหน้าได้\n\n“ส่วนที่ฝ่ายค้านบอก รัฐบาลกำลังไปหลอกนักลงทุนต่างชาติ ขอถามว่านักลงทุนขนาดนั้นจะไปหลอกมาได้อย่างไร และเชื่อมั่นว่าโครงการนี้จะเกิดขึ้นได้แน่นอน และจะทำให้จีดีพีประเทศไทยโต 5.5-6% และสร้างงานให้ประชาชนในพื้นที่ไม่ต่ำกว่า 2 แสนคน ผมเข้าใจฝ่ายค้าน เพราะคงไม่ได้เห็นบรรยากาศที่เราไปเจอกับนักลงทุน จึงไปจินตนาการว่าเกิดขึ้นไม่ได้ ส่วนข้อมูล สนข.จะเป็นจริงหรือไม่จริง จะตัดสินได้ด้วยนักลงทุนที่จะเข้ามา ซึ่งจะเป็นคำตอบได้ดีที่สุด” นายสุริยะกล่าว\n\nเมื่อถามถึงการเยียวยา ให้เกษตรกรและประชาชนที่ถูกเวนคืนที่ และได้รับผลกระทบ จะเห็นภาพได้ชัดเจนเมื่อใด นายสุริยะกล่าวว่า เมื่อเกิดผลตอบแทนที่ดีก็จะเริ่มการเยียวยาได้ ยืนยันว่าไม่มีปัญหา เมื่อถามย้ำว่ารัฐบาลยังไม่มีตัวเลขการเยียวยาที่ชัดเจน อาจส่งผลต่อการพูดคุยทำความเข้าใจกับประชาชน นายสุริยะกล่าวว่า นางมนพร เจริญศรี รมช.คมนาคม ลงพื้นที่ไปพูดคุยทำความเข้าใจกับชาวบ้านอยู่ตลอด จึงเชื่อว่าจะทำความเข้าใจได้\n\nผู้สื่อข่าวถามว่าชาวบ้านที่ อ.พะโต๊ะ จ.ชุมพร ที่ไม่มีเอกสารสิทธิในที่ดินจะได้รับการเยียวยาอย่างไร  รมว.คมนาคมกล่าวว่า จะพยายามหาทางเยียวยาให้ได้",
    url: "https://www.matichon.co.th/politics/news_4387974#lrolpvpfbkcdzem4jwm",
    platform: "internet",
    pinned: 1,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 0,
    negative_trend: 50,
    positive_trend: 50,
    arrow: "in",
    campaign_id: 1,
    keyword: "สุริยะ,แลนด์บริดจ์,ฝ่ายค้าน",
    created_date: "2024-01-22T11:29:58.000Z",
    updated_date: "2024-01-22T11:29:58.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 399,
    status: 1,
    approved: 1,
    title:
      '"ภูมิธรรม" อัด ป.ป.ช.ทำเกินหน้าที่ ปมเงินดิจิทัลวอลเล็ต ชี้โครงการยังไม่เกิด แต่บอกว่ามีการทุจริต ',
    description:
      '"ภูมิธรรม" อัด ป.ป.ช.ทำเกินหน้าที่ ปมเงินดิจิทัลวอลเล็ต ชี้โครงการยังไม่เกิด แต่บอกว่ามีการทุจริต ด้าน "ศิริกัญญา" เตือนหากรัฐบาลดันทุรังทำเงินดิจิทัล เดาไม่ออกจะจบตรงไหน',
    url: "https://x.com/MorningNewsTV3/status/1749284263219040583?s=20",
    platform: "twitter",
    pinned: 1,
    warned: 0,
    bombed: 1,
    boosted: 0,
    shares: 0,
    likes: 7,
    comments: 2,
    views: 5500,
    negative_trend: 50,
    positive_trend: 50,
    arrow: "in",
    campaign_id: 1,
    keyword: "เงินดิจิทัลวอลเล็ต",
    created_date: "2024-01-22T09:08:09.000Z",
    updated_date: "2024-01-22T09:55:42.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 384,
    status: 1,
    approved: 1,
    title:
      "นายกตระบัดสัตย์ก็สมควรโดนด่า ถ้าไม่ตระบัดสัตย์แต่แรกใครจะมาด่า นายกเสดถุยก็ถูกแล้ว",
    description:
      "นายกตระบัดสัตย์ก็สมควรโดนด่า ถ้าไม่ตระบัดสัตย์แต่แรกใครจะมาด่า นายกเสดถุยก็ถูกแล้ว",
    url: "https://x.com/JiminKawaiieiei/status/1696040505065566443?s=20",
    platform: "twitter",
    pinned: 1,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 10,
    comments: 0,
    views: 327,
    negative_trend: 70,
    positive_trend: 30,
    arrow: "in",
    campaign_id: 1,
    keyword: "นายกตระบัดสัตย์,นายกเสดถุย",
    created_date: "2024-01-22T07:47:34.000Z",
    updated_date: "2024-01-22T09:55:42.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 368,
    status: 1,
    approved: 1,
    title: "อีค่ายเขียวเน็ตเหี้ยอีกละเล่นอะไรก็กระตุกอีควาย",
    description: "อีค่ายเขียวเน็ตเหี้ยอีกละเล่นอะไรก็กระตุกอีควาย",
    url: "https://twitter.com/Yedammiee05/status/1748650060773003496",
    platform: "twitter",
    pinned: 1,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 19,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "ค่ายเขียว,เน็ตเหี้ย",
    created_date: "2024-01-22T07:19:32.000Z",
    updated_date: "2024-01-22T09:55:42.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 367,
    status: 1,
    approved: 1,
    title:
      "เน็ตค่ายเขียวเป็นไรอีก เดือนนี้ผมกดโหมดเครื่องบินไปเป็นสิบรอบละมั้ง",
    description:
      "เน็ตค่ายเขียวเป็นไรอีก เดือนนี้ผมกดโหมดเครื่องบินไปเป็นสิบรอบละมั้ง",
    url: "https://twitter.com/scrll_/status/1748736038929891548",
    platform: "twitter",
    pinned: 1,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 21,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว",
    created_date: "2024-01-22T07:18:31.000Z",
    updated_date: "2024-01-22T09:55:42.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 550,
    status: 1,
    approved: 1,
    title: "คนอย่างจิรายุ ไม่เคยก้มหัวให้เผด็จการ",
    description:
      "คนอย่างจิรายุ ไม่เคยก้มหัวให้เผด็จการ\n\nที่ผ่านมา 20 ปีเป็นเพียงการเล่นละครเพื่อการแย่งชิงอำนาจให้นายใหญ่ของตัวเองเท่านั้น ประชาชนเป็นเพียงเครื่องมือในการต่อรอง เมื่อผลประโยชน์ของเขาลงตัวกันแล้ว เขาก็เป็นพวกเดียวกัน แต่ที่น่าสมเพชคือยังมีคนที่ถูกหลอกซ้ำแล้วซ้ำเล่าก็ยังไม่เข็ด เขาเฉลยให้ดูชัดๆแบบไม่ต้องตีความแล้ว คนพวกนี้ก็ยังหลอกตัวเอง แบกพรรค 18 มงกุฎต่อไป ขณะที่คนหลายล้านเขาตาสว่างไปนานแล้ว",
    url: "https://x.com/SleeplessBKK/status/1749234710126248084?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 2300,
    likes: 1700,
    comments: 118,
    views: 149200,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 1,
    keyword: "จิรายุ ห่วงทรัพย์,เผด็จการ,แย่งชิงอำนาจ,พรรค18มงกุฎ",
    created_date: "2024-01-23T09:23:40.000Z",
    updated_date: "2024-01-23T09:23:40.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 549,
    status: 1,
    approved: 1,
    title:
      "คิดสิคิด..ถ้าเกือบ 20 ปีที่ผ่านมา #เพื่อไทย ไม่เรียนรู้ ไม่พยายามแก้ไขโครงสร้าง",
    description:
      "คิดสิคิด..ถ้าเกือบ 20 ปีที่ผ่านมา #เพื่อไทย ไม่เรียนรู้ ไม่พยายามแก้ไขโครงสร้าง ก็ยากที่ประเทศนี้จะดีขึ้น\nการสลายขั้วไปรวมกับพรรคลุง พรรคหนู เป็นการรีบเข้ามาแก้ปัญหาของประเทศจริงมั้ย #รัฐบาล",
    url: "https://x.com/Zan_di_/status/1748531385848258779?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 6,
    likes: 7,
    comments: 2,
    views: 726,
    negative_trend: 80,
    positive_trend: 20,
    arrow: "in",
    campaign_id: 1,
    keyword: "พรรคเพื่อไทย,สลายขั้ว,รัฐบาล",
    created_date: "2024-01-23T09:05:19.000Z",
    updated_date: "2024-01-23T09:05:19.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 548,
    status: 1,
    approved: 1,
    title: "เน็ต Ais จู่ก็ช้า",
    description:
      "เติมเน็ตมาใช้วันนึง ไม่ทราบว่ามันเป็นที่อะไร จู่ๆสัญญาณก็ช้า กลายเป็นตัว H แถมลูกศร mobile data ก็ไม่ส่งสัญญาณ เน็ต 1 วัน ราคา 45 บาท เร็ว 6mb ไม่ลดสปีด คือมันใช้กับคอมได้เลยนะ แล้วมาเป็นแบบนี้คืองง หัวเสียเลย ทำงานก็ไม่ได้ ถอดซิมก็แล้ว กดเปิดปิดเน็ตก็แล้ว",
    url: "https://pantip.com/topic/42474962#lead:related:SDknh6sNNcm3vswFvWnGjT:4:https://pantip.com/topic/42467505",
    platform: "pantip",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 2,
    views: 0,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เติมเน็ต,เร็ว6mbไม่ลดสปีด,mobile data",
    created_date: "2024-01-23T09:01:20.000Z",
    updated_date: "2024-01-23T09:01:20.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 547,
    status: 1,
    approved: 1,
    title: "เบื่อ True อยากจะย้ายไป AIS คิดว่าควรมั้ย?",
    description:
      "ตามหัวเรื่องเลย ช่วงนี้ไม่ค่อยแฮปปี้กับ True อยากย้ายแล้ว ลองแอบดูโปร AIS แพงกว่าหมดทั้งเน็ตมือถือทั้งเน็ตบ้าน แต่ถ้าสัญญาณดีกว่า เสถียรกว่า บริการดีกว่าก็โอเค อยากถามคนที่ใช้อยู่ AIS เป็นไงบ้างช่วงนี้ กลัวย้ายไปละจ่ายแพงกว่าแต่ห่วยพอกัน ^ ^",
    url: "https://pantip.com/topic/42474563#lead:related:SDknh6sNNcm3vswFvWnGjT:5:https://pantip.com/topic/42467505",
    platform: "pantip",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 3,
    views: 0,
    negative_trend: 20,
    positive_trend: 80,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตมือถือ,โปรAIS,สัญญาณดี",
    created_date: "2024-01-23T08:55:58.000Z",
    updated_date: "2024-01-23T08:55:58.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 546,
    status: 1,
    approved: 1,
    title: "เน็ตค่ายเขียวแย่เกินอ่ะคือใกล้หมดหรือไรนี่มันอืดเกิน",
    description: "เน็ตค่ายเขียวแย่เกินอ่ะคือใกล้หมดหรือไรนี่มันอืดเกิน",
    url: "https://twitter.com/mmyusn/status/1743992303768023434",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 21,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว,แย่เกิน",
    created_date: "2024-01-23T08:55:22.000Z",
    updated_date: "2024-01-23T08:55:22.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 545,
    status: 1,
    approved: 1,
    title: "สส เพื่อไทยมีแต่แบบนี้เหรอ ไม่ไหว มีแต่พวกฉุดรั้งความเจริญ",
    description: "สส เพื่อไทยมีแต่แบบนี้เหรอ ไม่ไหว มีแต่พวกฉุดรั้งความเจริญ",
    url: "https://x.com/pieakkana/status/1746914152847929509?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 2,
    comments: 0,
    views: 91,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 1,
    keyword: "พรรคเพื่อไทย",
    created_date: "2024-01-23T08:54:37.000Z",
    updated_date: "2024-01-23T08:54:37.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 544,
    status: 1,
    approved: 1,
    title:
      "เน็ตกากเหี้ยอุบ่าดแบบกุรับไม่ได้จริงๆ ย้ายไปค่ายไหนก็ไม่น่าดีไปมากกว่านี้ได้ เห้ออิเหี้ย ด่าทุกวันเพราะกากทุกวัน กากติดอันดับค่ะเน็ตค่ายเขียว ท้อ นอยอะ",
    description:
      "เน็ตกากเหี้ยอุบ่าดแบบกุรับไม่ได้จริงๆ ย้ายไปค่ายไหนก็ไม่น่าดีไปมากกว่านี้ได้ เห้ออิเหี้ย ด่าทุกวันเพราะกากทุกวัน กากติดอันดับค่ะเน็ตค่ายเขียว ท้อ นอยอะ",
    url: "https://twitter.com/Kangrakdekrek/status/1744025145810002270",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 14,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตกาก,ย้ายค่าย,ค่ายเขียว",
    created_date: "2024-01-23T08:53:28.000Z",
    updated_date: "2024-01-23T08:53:28.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 543,
    status: 1,
    approved: 1,
    title:
      "พรรคอื่นแสดงให้ ปชช เห็นแล้วว่าเค้ารักใคร่กลมเกลียวกันดี รักพวกพ้องมากกว่า ปชช ที่จ่ายภาษีขับเคลื่อนประเทศไทย",
    description:
      "พรรคอื่นแสดงให้ ปชช เห็นแล้วว่าเค้ารักใคร่กลมเกลียวกันดี รักพวกพ้องมากกว่า ปชช ที่จ่ายภาษีขับเคลื่อนประเทศไทย ทุกหยาดเหงื่อแรงงานของ ปชช สร้างประเทศนี้\nนับจากนี้ ช่วยกันสนับสนุน 3 พรรคนี้เท่านั้น\nก้าวไกล \n@MFPThailand\n \nไทยสร้างไทย \n@thaisangthai\n\nเป็นธรรม \n@FairPartyTH\n",
    url: "https://x.com/Zan_di_/status/1694292140841648234?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 23,
    likes: 81,
    comments: 2,
    views: 7600,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 1,
    keyword: "จ่ายภาษี,ประเทศไทย",
    created_date: "2024-01-23T08:52:51.000Z",
    updated_date: "2024-01-23T08:52:51.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 542,
    status: 1,
    approved: 1,
    title:
      "สัญญาณค่ายเขียวในบอคือโคตรกากสัดกระดอหมา จากเน็ต 6mbps เหมือนเหลือ 128kbps อะ หงุดหงิดมาก",
    description:
      "สัญญาณค่ายเขียวในบอคือโคตรกากสัดกระดอหมา จากเน็ต 6mbps เหมือนเหลือ 128kbps อะ หงุดหงิดมาก",
    url: "https://twitter.com/tothemoon1129/status/1744233364616601787",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 19,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "สัญญาณค่ายเขียว,โคตรกาก",
    created_date: "2024-01-23T08:51:20.000Z",
    updated_date: "2024-01-23T08:51:20.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 540,
    status: 1,
    approved: 1,
    title:
      "พนักงานเน็ตค่ายเขียวขายแพคเสริมให้กูละบริการเหี้ย แต่กุหายโกรธละเพราะคอลเซนเตอร์ที่โทรไปคุยด้วยพูดจาดี ไม่เหวี่ยงลูกค้า อธิบายดี",
    description:
      "พนักงานเน็ตค่ายเขียวขายแพคเสริมให้กูละบริการเหี้ย แต่กุหายโกรธละเพราะคอลเซนเตอร์ที่โทรไปคุยด้วยพูดจาดี ไม่เหวี่ยงลูกค้า อธิบายดี",
    url: "https://twitter.com/born2bseksygurl/status/1744634807915893032",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 37,
    negative_trend: 50,
    positive_trend: 50,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว,คอลเซ็นเตอร์,บริการเหี้ย,พนักงานเน็ต",
    created_date: "2024-01-23T08:47:40.000Z",
    updated_date: "2024-01-23T08:47:40.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 539,
    status: 1,
    approved: 1,
    title:
      "ครูเวรเฮ เศรษฐา เผยครม.ยกเลิกมติปี 42 ครูไม่ต้องเข้าเวรแล้ว หลังเกิดเหตุถูกทำร้าย ",
    description:
      "ครูเวรเฮ เศรษฐา เผยครม.ยกเลิกมติปี 42 ครูไม่ต้องเข้าเวรแล้ว หลังเกิดเหตุถูกทำร้าย ชี้เทคโนโลยี-สภาพแวดล้อมเปลี่ยน\n.\nเมื่อเวลา 11.30 น. วันที่ 23 ม.ค.67 ที่หอประชุมคอซู้เจียง ศูนย์ราชการจังหวัดระนอง นายเศรษฐา ทวีสิน นายกรัฐมนตรีและรมว.คลัง ให้สัมภาษณ์ถึงกรณีเหตุการณ์คนร้ายทำร้ายครูระหว่างการเข้าเวรในพื้นที่จ.เชียงราย ว่า\n\nเมื่อเร็วๆ นี้มีเหตุการณ์ความรุนแรงเกิดขึ้นกับครูขณะอยู่เวร คณะรัฐมนตรี (ครม.) พิจารณายกเว้นมติ ครม. เมื่อวันที่ 6 ก.ค.2542 ซึ่งกว่า 20 ปีที่แล้ว ปัจจุบันมีการพัฒนาทางด้านเทคโนโลยีและสภาพแวดล้อมได้เปลี่ยนไป จึงให้ยกเลิก ยกเว้น\n\nโดยให้มีมาตรการรักษาความปลอดภัยให้ดียิ่งขึ้น ซึ่งหน่วยงานต่างๆ จะรับไปพิจารณาต่อไป\n\nและสั่งการให้กระทรวงมหาดไทย กระทรวงแรงงาน สำนักงานตำรวจแห่งชาติ (ตร.) ดูแลความปลอดภัยพี่น้องประชาชนทั้งประเทศ หรือเร่งจัดหางานไม่ให้เกิดความรุนแรงของกลุ่มวัยรุ่น ซึ่งเริ่มมีพฤติกรรมที่เป็นภัยต่อสังคม",
    url: "https://www.tiktok.com/@gurion99/photo/7327179101243034885?is_from_webapp=1&sender_device=pc&web_id=7142765204576224769",
    platform: "tiktok",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 13,
    likes: 502,
    comments: 40,
    views: 21700,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "ครูเวร,เศรษฐา ทวีสิน,ถูกทำร้าย,นายกรัฐมนตรี",
    created_date: "2024-01-23T08:46:48.000Z",
    updated_date: "2024-01-23T08:46:48.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 538,
    status: 1,
    approved: 1,
    title:
      "ขอด่าหน่อยได้ไหม ทนมาหลายรอบแล้วกับอีเน็ตค่ายเขียว ห่วยมากทั้ง wifi ทั้ง mobile",
    description:
      "ขอด่าหน่อยได้ไหม ทนมาหลายรอบแล้วกับอีเน็ตค่ายเขียว ห่วยมากทั้ง wifi ทั้ง mobile",
    url: "https://twitter.com/freedom_narika/status/1744818839228215326",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 33,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว,wifi,mobile",
    created_date: "2024-01-23T08:45:50.000Z",
    updated_date: "2024-01-23T08:45:50.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 537,
    status: 1,
    approved: 1,
    title:
      "ไหนว่าทักษิณไม่เกี่ยวกับ #รัฐบาล ไม่เกี่ยวกับ #เพื่อไทย สรุปที่เราจะทำโครงการ #แลนด์บริดจ์",
    description:
      "ไหนว่าทักษิณไม่เกี่ยวกับ #รัฐบาล ไม่เกี่ยวกับ #เพื่อไทย\nสรุปที่เราจะทำโครงการ #แลนด์บริดจ์ นี่ก็เพื่อให้ฝันของ\nอดีต ฯพณฯท่านนายก พันตำรวจโท.ดร.ทักษิณ ชินวัตร เป็นจริงหรือครับ!?\nเราทำโคงการเพราะคุ้มค่า หรือทำเพราะเชื่อทักษิณ",
    url: "https://x.com/Zan_di_/status/1749648572210110562?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 8,
    comments: 2,
    views: 321,
    negative_trend: 70,
    positive_trend: 30,
    arrow: "in",
    campaign_id: 1,
    keyword: "รัฐบาล,พรรคเพื่อไทย,แลนด์บริดจ์",
    created_date: "2024-01-23T08:44:56.000Z",
    updated_date: "2024-01-23T08:44:56.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 536,
    status: 1,
    approved: 1,
    title: "เน็ตค่ายเขียวเป็นไรเดี๋ยวเชื่อมเดี๋ยวหลุด",
    description: "เน็ตค่ายเขียวเป็นไรเดี๋ยวเชื่อมเดี๋ยวหลุด",
    url: "https://twitter.com/littlemuzikb2/status/1745019262455136407",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 69,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว",
    created_date: "2024-01-23T08:44:15.000Z",
    updated_date: "2024-01-23T08:44:15.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 535,
    status: 1,
    approved: 1,
    title: "เน็ตค่ายเขียวกากมากกกกกก ขยันหลุดเก่งสุด หน่วงมาก",
    description: "เน็ตค่ายเขียวกากมากกกกกก ขยันหลุดเก่งสุด หน่วงมาก",
    url: "https://twitter.com/MikiMiki_ELF130/status/1745054959086002286",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 32,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว,กากมาก",
    created_date: "2024-01-23T08:43:17.000Z",
    updated_date: "2024-01-23T08:43:17.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 534,
    status: 1,
    approved: 1,
    title: "สถานการณ์ตลาดหุ้นไทยตอนนี้ เข้าทางนายกเต็มๆเลยครับ มันต้องกู้!!",
    description:
      "สถานการณ์ตลาดหุ้นไทยตอนนี้เข้าทางนายกเลยครับ ตลาดหุ้นร่วงติดต่อกันหลายวัน สภาพเศรษฐกิจแย่ กำลังเข้าขั้นวิฤติ แบบนี้มาตรการดิจิตอลวอเล็ตของรัฐบาลต้องเดินหน้าต่อไป ต้องอณุมัติเงินกู้500,000ล้านบาท\nเพื่อนกระตุ้นเศรษฐกิจภายในประเทศ",
    url: "https://pantip.com/topic/42476143",
    platform: "pantip",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 3,
    comments: 13,
    views: 0,
    negative_trend: 70,
    positive_trend: 30,
    arrow: "in",
    campaign_id: 1,
    keyword: "ตลาดหุ้นไทย,นายก,มันต้องกู้,กระตุ้นเศรษฐกิจ",
    created_date: "2024-01-23T08:42:34.000Z",
    updated_date: "2024-01-23T08:42:34.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 533,
    status: 1,
    approved: 1,
    title: "ไอ่เหี้ย เน็ตค่ายเขียวเลิกตัดได้ละไอ่สัด",
    description: "ไอ่เหี้ย เน็ตค่ายเขียวเลิกตัดได้ละไอ่สัด",
    url: "https://twitter.com/lowqpers144p/status/1745115690678575352",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 30,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว",
    created_date: "2024-01-23T08:41:26.000Z",
    updated_date: "2024-01-23T08:41:26.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 532,
    status: 1,
    approved: 1,
    title: "ศิริกัญญา ตันเจริญ ทางออกปัญหาเศรษฐกิจไทย ไม่ใช่แจกเงินระยะสั้น",
    description:
      "ศิริกัญญา ตันเจริญ ทางออกปัญหาเศรษฐกิจไทย ไม่ใช่แจกเงินระยะสั้น",
    url: "https://www.tiktok.com/@matichontv/video/7326520603438091521?is_from_webapp=1&sender_device=pc&web_id=7142765204576224769",
    platform: "tiktok",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 55,
    likes: 1711,
    comments: 122,
    views: 18900,
    negative_trend: 80,
    positive_trend: 20,
    arrow: "in",
    campaign_id: 1,
    keyword: "ศิริกัญญา ตันเจริญ,เศรษฐกิจไทย,แจกเงิน",
    created_date: "2024-01-23T08:40:34.000Z",
    updated_date: "2024-01-23T08:40:34.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 531,
    status: 1,
    approved: 1,
    title:
      "เน็ตค่ายเขียวมึงเป็นควยไร สัญญาณไม่เคยจะดีอิสัส ไม่ได้ขอเน็ตมึงฟรีนะ",
    description:
      "เน็ตค่ายเขียวมึงเป็นควยไร สัญญาณไม่เคยจะดีอิสัส ไม่ได้ขอเน็ตมึงฟรีนะ",
    url: "https://twitter.com/Cyxthi3/status/1745277983718256863",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 24,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว",
    created_date: "2024-01-23T08:39:05.000Z",
    updated_date: "2024-01-23T08:39:05.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 530,
    status: 1,
    approved: 1,
    title: "ทำไมคนจะตั้งใจเรียน เน็ตค่ายเขียวต้องดับฝัน",
    description: "ทำไมคนจะตั้งใจเรียน เน็ตค่ายเขียวต้องดับฝัน",
    url: "https://twitter.com/aliceiswaris/status/1745419996539596945",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 44,
    negative_trend: 50,
    positive_trend: 50,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว",
    created_date: "2024-01-23T08:36:56.000Z",
    updated_date: "2024-01-23T08:36:56.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 529,
    status: 1,
    approved: 1,
    title: "เน็ตเหี้ยทุกวันแบบนี้ก็ไม่ไหวนะค่ายเขียว",
    description: "เน็ตเหี้ยทุกวันแบบนี้ก็ไม่ไหวนะค่ายเขียว",
    url: "https://twitter.com/inautumn25/status/1745427452971864562",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 20,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตเหี้ย,ค่ายเขียว",
    created_date: "2024-01-23T08:34:57.000Z",
    updated_date: "2024-01-23T08:34:57.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 528,
    status: 1,
    approved: 1,
    title: "เน็ตค่ายเขียวเน่ามากกกก นี่ขนาดรายเดือนนะ งง",
    description: "เน็ตค่ายเขียวเน่ามากกกก นี่ขนาดรายเดือนนะ งง",
    url: "https://twitter.com/dream_c2t/status/1745650612157677988",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 99,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว,เน่ามาก",
    created_date: "2024-01-23T08:33:44.000Z",
    updated_date: "2024-01-23T08:33:44.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 527,
    status: 1,
    approved: 1,
    title:
      "จ่ายค่าทรศแต่ละเดือนแล้วรู้สึกจนมากค่าทรศอย่างแพงแต่เน็ตค่ายเขียวก็ขยันล่มเหลือเกิน",
    description:
      "จ่ายค่าทรศแต่ละเดือนแล้วรู้สึกจนมากค่าทรศอย่างแพงแต่เน็ตค่ายเขียวก็ขยันล่มเหลือเกิน",
    url: "https://twitter.com/taysaidilovenew/status/1745657978651648215",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 27,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายเขียว,ขยันล่ม",
    created_date: "2024-01-23T08:32:43.000Z",
    updated_date: "2024-01-23T08:32:43.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 526,
    status: 1,
    approved: 1,
    title:
      "ถ้าคุณสงสัยว่าเปลี่ยนรัฐบาลแล้วทำไมชาวบ้านยังไม่รู้สึกว่าชีวิตเขามีอะไรดีขึ้นมาเลยนอกจากเห็นนายกเซลล์แมนไปเดินสายถ่ายรูปโชว์ต่างประเทศ",
    description:
      "ถ้าคุณสงสัยว่าเปลี่ยนรัฐบาลแล้วทำไมชาวบ้านยังไม่รู้สึกว่าชีวิตเขามีอะไรดีขึ้นมาเลยนอกจากเห็นนายกเซลล์แมนไปเดินสายถ่ายรูปโชว์ต่างประเทศ คุณเข้าใจถูกแล้วหล่ะ",
    url: "https://x.com/SleeplessBKK/status/1749688431691878477?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 856,
    likes: 589,
    comments: 41,
    views: 20000,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 1,
    keyword: "เปลี่ยนรัฐบาล, นายกเซลล์แมน,ต่างประเทศ",
    created_date: "2024-01-23T08:29:44.000Z",
    updated_date: "2024-01-23T08:29:44.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 525,
    status: 1,
    approved: 1,
    title:
      "ตั้งแต่ 3BB ไปอยู่กับค่ายเขียว เหี้ยเลย แต่ก่อนนี้โน .1 เลย เรื่องเสถียรเนี่ย เล่นเกมส์ไม่เคยเรทตก อันนี้ตกเป็นแบบเดียวกับเน็ตมือถือ เซ็ง อยากเปลี่ยนแต่ก็เกลียดทรู เนี่ยความผูกขาดของเจ้าในไทย",
    description:
      "ตั้งแต่ 3BB ไปอยู่กับค่ายเขียว เหี้ยเลย แต่ก่อนนี้โน .1 เลย เรื่องเสถียรเนี่ย เล่นเกมส์ไม่เคยเรทตก อันนี้ตกเป็นแบบเดียวกับเน็ตมือถือ เซ็ง อยากเปลี่ยนแต่ก็เกลียดทรู เนี่ยความผูกขาดของเจ้าในไทย",
    url: "https://twitter.com/H0W199X/status/1745996922358583381",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 187,
    negative_trend: 50,
    positive_trend: 50,
    arrow: "around",
    campaign_id: 2,
    keyword: "3BB,ค่ายเขียว,เน็ตมือถือ,ทรู",
    created_date: "2024-01-23T08:29:27.000Z",
    updated_date: "2024-01-23T08:29:27.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 524,
    status: 1,
    approved: 1,
    title:
      "นิด้าโพล ชี้เคส ‘นักโทษเทวดา’ ไม่กระทบความอยู่รอดของรัฐบาล เชื่อปลุกม็อบไม่ขึ้น",
    description:
      "ศูนย์สำรวจความคิดเห็น “นิด้าโพล” สถาบันบัณฑิตพัฒนบริหารศาสตร์ (นิด้า) เปิดเผยผลสำรวจของประชาชน เรื่อง “กรณีทักษิณชินวัตรกับความอยู่รอดของรัฐบาล” ทำการสำรวจระหว่างวันที่ 15-17 มกราคม 2567 จากประชาชนที่มีอายุ 18 ปีขึ้นไป กระจายทุกภูมิภาค ระดับการศึกษา อาชีพ และรายได้ ทั่วประเทศ รวมทั้งสิ้น จำนวน 1,310 หน่วยตัวอย่าง เกี่ยวกับกรณีทักษิณ ชินวัตรกับความอยู่รอดของรัฐบาล การสำรวจอาศัยการสุ่มตัวอย่างโดยใช้ความน่าจะเป็นจากบัญชีรายชื่อฐานข้อมูลตัวอย่างหลัก (Master Sample) ของ “นิด้าโพล” สุ่มตัวอย่างแบบหลายขั้นตอน (Multi-stage Sampling) เก็บข้อมูลด้วยวิธีการสัมภาษณ์ทางโทรศัพท์ โดยกำหนดค่าความเชื่อมั่น ร้อยละ 97.0",
    url: "https://www.thaipost.net/politics-news/521012/",
    platform: "internet",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 0,
    negative_trend: 10,
    positive_trend: 90,
    arrow: "in",
    campaign_id: 1,
    keyword: "นิด้าโพล,นักโทษเทวดา,รัฐบาล,ปลุกม็อบ,ทักษิณ ชินวัตร",
    created_date: "2024-01-23T08:28:36.000Z",
    updated_date: "2024-01-23T08:28:36.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 523,
    status: 1,
    approved: 1,
    title:
      "รอบนี้ถ้าเพื่อไทยประกาศว่าจะไม่จับมือก้าวไกลจัดตั้งรัฐบาลฉันจะกาให้เพื่อไทย 2 ใบเลยค่ะ",
    description:
      "รอบนี้ถ้าเพื่อไทยประกาศว่าจะไม่จับมือก้าวไกลจัดตั้งรัฐบาลฉันจะกาให้เพื่อไทย 2 ใบเลยค่ะ",
    url: "https://x.com/autotrs1/status/1749708351133594097?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 1,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "พรรคเพื่อไทย,จัดตั้งรัฐบาล,พรรคก้าวไกล",
    created_date: "2024-01-23T08:22:51.000Z",
    updated_date: "2024-01-23T08:22:51.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 522,
    status: 1,
    approved: 1,
    title:
      "ปากกล้าขาสั่น! 'เศรษฐา' ลั่นพร้อมชี้แจงทุกเรื่องตามรธน. หลังสว.ยื่นซักฟอกรัฐบาล",
    description:
      "ที่หอประชุมคอซู้เจียง ศูนย์ราชการจังหวัดระนอง นายเศรษฐา ทวีสิน นายกรัฐมนตรีและรมว.คลัง ให้สัมภาษณ์ถึงกรณีสมาชิกวุฒิสภา (สว.) ยื่นญัตติเพื่อขอเปิดอภิปรายทั่วไปแบบไม่ลงมติ ตามรัฐธรรมนูญ มาตรา 153 รัฐบาลจะพิจารณาวันสะดวกในช่วงไหน ว่า ยังไม่ทราบเลย ต้องให้ นางมนพร เจริญศรี รมช.คมนาคม ซึ่งทำหน้าที่เป็นผู้ประสานงานระหว่างสภากับครม. เป็นผู้กำหนดวันที่จะอภิปรายไม่ไว้วางใจ\n\nผู้สื่อข่าวถามว่า ในส่วนของรัฐบาลพร้อมที่จะชี้แจงทุกข้อใช่หรือไม่ นายกฯ กล่าวว่า ในส่วนรัฐบาลพร้อมชี้แจงทุกเรื่องเพราะเป็นไปตามรัฐธรรมนูญ หากมีการเข้าชื่อได้ครบแล้ว เราก็ต้องตอบฝ่ายนิติบัญญัติเป็นธรรมดา.",
    url: "https://www.thaipost.net/politics-news/522088/",
    platform: "internet",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 0,
    negative_trend: 50,
    positive_trend: 50,
    arrow: "in",
    campaign_id: 1,
    keyword: "เศรษฐา ทวีสิน,ซักฟอกรัฐบาล,รัฐธรรมนูญ,สว.",
    created_date: "2024-01-23T08:22:35.000Z",
    updated_date: "2024-01-23T08:22:35.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 521,
    status: 1,
    approved: 1,
    title: "เน็ตค่ายAIS หลังๆมาห่วยมากค่ะ",
    description:
      "เราเป็นคนนึงที่ใช้ค่ายนี้มานานมาก แต่ก่อนโปรเน็ตก็ดีมากๆเร็วมากๆ แต่ช่วงไม่กี่เดือนมานี้โปรเน็ตหมดสัญญาไป เราเลยได้เน็ตใหม่มาแทน 250บาท เน็ต10GB ไม่อั้น15Mbps (ปล.ลดสปีดด้วยน้ะ้จ้ะ) คือช้ามากกก มากๆๆๆ ทำอะไรเล่นอะไรไม่ได้ แม้แต่คอลmessengerยังแทบจะไม่ไหว ตอนแรกก็นึกว่าเป็นกับพื้นที่ แต่อยู่ไหนก็เป็นเพลียจิต ติดต่อคอลเซ็นเตอร์ก็ยากเหลือเกิน ไม่ไหวแล้วค่ะอยากย้ายค่ายจริงๆแต่ไม่อยากทิ้งเบอร์เก่าใช้มานานมาก",
    url: "https://pantip.com/topic/42474730#lead:related:RXCkAnzXfTR6wEFvgAn13S:2:https://pantip.com/topic/42447016",
    platform: "pantip",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 2,
    views: 0,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "เน็ตค่ายAIS,ห่วยมาก,คอลเซ็นเตอร์",
    created_date: "2024-01-23T08:21:52.000Z",
    updated_date: "2024-01-23T08:21:52.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 520,
    status: 1,
    approved: 1,
    title:
      "ฉิบหายแล้ว! โฆษกรัฐบาลผิดคิว อ้างเอกสารลับคลังแค่ร่าง ยังไม่ได้ตรวจทาน ขออย่าเพิ่งเผยแพร่",
    description:
      "ผู้สื่อข่าวรายงานว่า ภายหลังนายชัย วัชรงค์ โฆษกประจำสำนักนายกรัฐมนตรี ได้เผยแพร่เอกสารลับการประมาณการเศรษฐกิจไทยในปี 2566 และ ปี 2567 ของกระทรวงการคลัง ในกลุ่มไลน์สื่อมวลชนประจำทำเนียบรัฐบาล เมื่อเวลา 07.28 น. ซึ่งสื่อมวลชนได้นำไปเสนอข่าวอย่างกว้างขวางแล้ว\n\nต่อมาเวลา 11.00 น. นายชัย ได้ส่งไลน์ชี้แจงถึงเอกสารดังกล่าวว่า “ขอเรียนพี่น้องนักข่าวว่า ข้อมูลรายงานข้างต้น ยังเป็นเพียงฉบับร่างเท่านั้น ยังจะต้องมีการตรวจทานความถูกต้องทั้งตัวเลขและข้อความอยู่ ดังนั้น ขอได้โปรดอย่างเพิ่งนำออกไปเผยแพร่จนกว่าจะได้รับการยืนยันอย่างเป็นทางการจากกระทรวงการคลัง ขออภัยในความไม่สะดวกมา ณ ที่นี้ด้วยครับ” จากนั้นนายชัยได้ยกเลิกข้อความที่เป็นไฟล์เอกสารลับดังกล่าวเมื่อช่วงเช้าไปด้วย.",
    url: "https://www.thaipost.net/politics-news/522057/",
    platform: "internet",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 0,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 1,
    keyword:
      "โฆษกรัฐบาล,เอกสารลับ,ชัย วัชรงค์,ทำเนียบรัฐบาล,กระทรวงการคลัง,ฉิบหายแล้ว",
    created_date: "2024-01-23T08:17:21.000Z",
    updated_date: "2024-01-23T08:17:21.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 519,
    status: 1,
    approved: 1,
    title: "‘เศรษฐา’จัดงบ‘3.48ล้านล.’ พลิกฟื้นเศรษฐกิจประเทศ",
    description:
      "หมายเหตุ – นายเศรษฐา ทวีสิน นายกรัฐมนตรีและรัฐมนตรีว่าการกระทรวงการคลัง แถลงร่างพระราชบัญญัติงบประมาณรายจ่าย  ประจำปีงบประมาณ พ.ศ.2567 วงเงิน 3.48 ล้านล้านบาท ต่อสภาผู้แทนราษฎร มีเนื้อหาสาระสำคัญดังนี้\n\nคณะรัฐมนตรีขอเสนอร่างพระราชบัญญัติ (พ.ร.บ.) งบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ.2567 โดยมีหลักการและเหตุผล ดังนี้\n\n•หลักการ\n\nตั้งงบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ.2567 เป็นจำนวนไม่เกิน 3,480,000,000,000 บาท (สามล้านสี่แสนแปดหมื่นล้านบาท) สำหรับเป็นค่าใช้จ่ายของหน่วยรับงบประมาณ เป็นจำนวน 3,361,638,869,500 บาท (สามล้านสามแสนหกหมื่นหนึ่งพันหกร้อยสามสิบแปดล้านแปดแสนหกหมื่นเก้าพันห้าร้อยบาท) เพื่อชดใช้เงินคงคลัง เป็นจำนวน 118,361,130,500 บาท (หนึ่งแสนหนึ่งหมื่นแปดพันสามร้อยหกสิบเอ็ดล้านหนึ่งแสนสามหมื่นห้าร้อยบาท)\n\n•เหตุผล\n\nเพื่อให้หน่วยรับงบประมาณได้มีกรอบวงเงินงบประมาณสำหรับใช้จ่ายในปีงบประมาณ พ.ศ.2567\n\nร่าง พ.ร.บ.งบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ.2567 ที่รัฐบาลนำเสนอต่อสมาชิกสภาผู้แทนราษฎร เป็นเครื่องมือสำคัญในการขับเคลื่อนนโยบายของรัฐบาลตามที่ได้แถลงไว้ต่อรัฐสภา โดยรัฐบาลได้ดำเนินการให้สอดคล้องกับสภาวะทางเศรษฐกิจ และฐานะทางการเงินการคลังของประเทศ ตลอดจนแนวทางการพัฒนาประเทศตามยุทธศาสตร์ชาติ แผนแม่บทภายใต้ยุทธศาสตร์ชาติ แผนพัฒนาเศรษฐกิจและสังคมแห่งชาติ ฉบับที่ 13 นโยบายและแผนระดับชาติว่าด้วยความมั่นคงแห่งชาติ และเป้าหมายการพัฒนาที่ยั่งยืน เพื่อให้เกิดผลสัมฤทธิ์ และประโยชน์สูงสุดต่อประชาชนอย่างเป็นรูปธรรม\n\n•ภาวะเศรษฐกิจทั่วไป\n\nตามแถลงภาวะเศรษฐกิจของสภาพัฒนาการเศรษฐกิจและสังคมแห่งชาติ (สศช.) ณ วันที่ 20 พฤศจิกายน 2566 เศรษฐกิจไทยในปี 2566 คาดว่าจะขยายตัวร้อยละ 2.5 ซึ่งเป็นเป้าล่าสุดในไตรมาสที่ 3 โดยเป็นเป้าหมายที่ถูกปรับมาเรื่อยๆ โดยหลายหน่วยงาน\n\nเป้าหมายการขยายตัวนี้ มีปัจจัยสนับสนุนจากการขยายตัวของการอุปโภคบริโภคภาคเอกชน การฟื้นตัวของภาคการท่องเที่ยวตามการขยายตัวของนักท่องเที่ยวต่างชาติ และการขยายตัวอย่างต่อเนื่องของการลงทุนภาคเอกชน อย่างไรก็ตาม ยังมีข้อจำกัดและปัจจัยเสี่ยงจากแนวโน้มการชะลอตัวของเศรษฐกิจโลกที่มีผลต่อภาคการส่งออกสินค้า และภาคการผลิตอุตสาหกรรม รวมทั้งภาระหนี้สินครัวเรือนและภาคธุรกิจที่ยังอยู่ในระดับสูง และความเสี่ยงจากความแปรปรวนของสภาพภูมิอากาศที่อาจส่งผลกระทบต่อภาคการเกษตร โดยคาดว่าอัตราเงินเฟ้อจะอยู่ที่เฉลี่ยร้อยละ 1.4 และดุลบัญชีเดินสะพัดเกินดุลร้อยละ 1.0 ต่อผลิตภัณฑ์มวลรวมในประเทศ\n\nสศช.ได้ประเมินไว้ว่า เศรษฐกิจในปี 2567 คาดว่าจะขยายตัวในช่วงร้อยละ 2.7-3.7 โดยมีปัจจัยสนับสนุนจากการขยายตัวของภาคการส่งออก การอุปโภคบริโภคและการลงทุนภาคเอกชน รวมทั้งการฟื้นตัวอย่างต่อเนื่องของภาคการท่องเที่ยว โดยคาดว่าอัตราเงินเฟ้อจะอยู่ในช่วงร้อยละ 1.7-2.7 และดุลบัญชีเดินสะพัดเกินดุลร้อยละ 1.5 ต่อผลิตภัณฑ์มวลรวมในประเทศ\n\nความสัมพันธ์ของงบประมาณรายจ่ายและแผนการพัฒนาประเทศงบประมาณรายจ่ายปี พ.ศ.2567 มุ่งทำให้ประชาชนมีชีวิตที่ดีขึ้นผ่านการดำเนินนโยบายที่จะครอบคลุมทั้งด้านเศรษฐกิจ สังคม และการเมือง โดยมีการดำเนินการทั้งระยะเร่งด่วน เพื่อแก้ไขปัญหาระยะสั้นและนโยบายระยะกลางและยาว เพื่อเสริมขีดความสามารถในการเจริญเติบโตของประเทศ\n\nเศรษฐกิจจึงเป็นเรื่องที่รัฐบาลให้ความสำคัญเป็นอันดับต้นๆ เนื่องมาจากประชาชนจำนวนมากได้รับผลกระทบโดยตรง จึงเป็นความจำเป็นเร่งด่วนของรัฐบาลนี้ที่จะพลิกฟื้นเศรษฐกิจในระยะสั้น โดยเริ่มจากการสร้างอุปสงค์ (Demand) ในกลุ่มเป้าหมายของนโยบาย นำไปสู่การผลิตสินค้า ที่จะต้องมีการลงทุนในอุตสาหกรรมต่างๆ เพื่อขยายการผลิต ก่อให้เกิดการขยายอุปทาน (Supply) มีการพัฒนาขีดความสามารถในภาคอุตสาหกรรม ยกระดับการผลิตและพัฒนาห่วงโซ่อุปทานให้ใช้เทคโนโลยีที่ดีขึ้นทั้งประเทศ\n\nการท่องเที่ยวยังคงจะเป็นกลไกที่สำคัญในการพัฒนาเศรษฐกิจ โดยทำให้การท่องเที่ยวเข้าถึงเมืองรองมากขึ้น สร้างงานและอาชีพในพื้นที่ดังกล่าว เพิ่มมูลค่าให้กับสินค้าและบริการในพื้นที่ โดยรัฐบาลจะดึงดูดการท่องเที่ยวด้วยมาตรการต่างๆ ปรับปรุงโครงสร้างพื้นฐานที่จำเป็น นำจุดเด่นทางวัฒนธรรมไปนำเสนอให้กับเวทีโลก สนับสนุนการใช้อัตลักษณ์ของไทยให้เกิดประโยชน์ ซึ่งจะนำไปสู่การพัฒนา Soft Power ของประเทศในระยะยาวด้วย\n\nในขณะเดียวกัน ประชาชนจำนวนมากเดือดร้อนจากค่าใช้จ่ายที่สูงขึ้น\n\nในช่วงหลายปีที่ผ่านมา ซึ่งเป็นที่มาของนโยบายการลดรายจ่ายต่างๆ ไม่ว่าจะเป็นการแก้ไขปัญหาหนี้ทั้งระบบ ซึ่งครอบคลุมไปถึงหนี้นอกระบบและหนี้ในระบบ การลดราคาพลังงาน ซึ่งได้ดำเนินการไปแล้ว และกำลังอยู่ในระหว่างการปรับโครงสร้างพลังงานให้เหมาะสม ซึ่งจะทำให้ประชาชนมีค่าใช้จ่ายที่ลดลง\nอย่างมีนัยสำคัญ ในขณะที่ภาคอุตสาหกรรมก็จะสามารถแข่งขันได้มากขึ้น\n\nประชาชนไทยจะเข้าถึงแหล่งงานที่มีคุณค่ามากขึ้น สามารถพัฒนาความรู้ความสามารถที่มาจากภาคอุตสาหกรรมและภาคเอกชนระดับโลกได้\n\nในการลงทุน วางแผนลงทุนด้านโครงสร้างพื้นฐานที่จำเป็นที่จะเอื้อให้เกิดการลงทุนเกี่ยวเนื่องให้ครอบคลุมทุกมิติ การคมนาคมในประเทศจะสะดวกสบายมากขึ้น สามารถรองรับความต้องการได้ในทุกมิติไม่ว่าจะเป็นทางถนน ทางน้ำ ทางราง และทางอากาศ และทำให้ระบบการคมนาคมและโลจิสติกส์มีประสิทธิภาพ กลายเป็นหนึ่งในจุดแข็งของประเทศไทย เช่น การเชื่อมโยงข้อมูลอิเล็กทรอนิกส์ (National Single Window) ที่จะทำให้ขั้นตอนการยื่นเอกสารและดำเนินกิจกรรมที่เกี่ยวข้องกับภาครัฐสะดวกและง่ายดายมากขึ้น เป็นต้น\n\nประเทศไทยจะมีการลงทุนเรื่องน้ำที่ครอบคลุมทั้งระบบ เช่น น้ำในภาคการผลิต ภาคเกษตร ภาคอุตสาหกรรม\n\nทรัพยากรธรรมชาติจะได้รับการดูแล อนุรักษ์ ฟื้นฟู ทั้งป่าไม้ ป่าชายเลน ทะเล ชายฝั่ง ซึ่งเป็นสินทรัพย์ทางธรรมชาติของประเทศ อากาศจะต้องสะอาด ฝุ่นพิษจะต้องได้รับการแก้ไขอย่างเร่งด่วน และประเทศไทยจะเดินหน้าลดก๊าซเรือนกระจกอย่างต่อเนื่อง\n\nอีกด้านหนึ่งที่รัฐบาลให้ความสำคัญ คือด้านสังคมและความมั่นคง โดยประชาชนคนไทยจะต้องมีสุขภาวะที่ดีทั้งสุขภาพกาย สุขภาพใจ เข้าถึงงานบริการสาธารณสุขได้อย่างรวดเร็วมากยิ่งขึ้น ไม่จำเป็นต้องไปต่อคิวอีกต่อไป โดยรัฐจะลงทุนการเชื่อมต่อข้อมูลทั้งระบบ อัพเกรดระบบ 30 บาทรักษาทุกโรคให้ดียิ่งขึ้น\n\nรัฐบาลจะดูแลลูกหลานประชาชนที่ได้รับผลกระทบจากยาเสพติด โดยการปรับปรุงหลักเกณฑ์ผู้เสพให้เป็นผู้ป่วย รวมทั้งจะสกัดกั้นยาเสพติดที่ลักลอบข้ามพรมแดนไม่ให้สามารถเข้ามาแพร่กระจายได้\n\nด้านอัตลักษณ์และความเสมอภาค รัฐบาลจะทำให้คนทุกกลุ่มได้รับการคุ้มครองทางกฎหมาย โดยปราศจากเงื่อนไขทางเพศสภาพ อายุ ความเจ็บป่วยของร่างกาย ทำให้ได้รับสิทธิครบถ้วนตามที่กำหนดไว้ และเข้าถึงโอกาสต่างๆ เพื่อสร้างความเสมอภาคทางสังคมที่แท้จริง\n\nรัฐบาลจะพัฒนากองทัพให้มีความทันสมัยมากยิ่งขึ้น สอดคล้องไปกับการพัฒนาความมั่นคงในทุกรูปแบบและให้ตรงกับยุคสมัย ระบบการเกณฑ์ทหารจะเปลี่ยนเป็นแบบสมัครใจ\n\nด้านการพัฒนาศักยภาพของคนไทย ประชาชนจะต้องได้รับการศึกษาที่เข้าถึงได้ พัฒนาสถาบันการศึกษาให้มีคุณภาพ และพัฒนาหลักสูตรให้มีมาตรฐานและทันต่อยุคสมัย รวมทั้งขยายโอกาสทางการศึกษาให้ครอบคลุมไปถึงระดับวิชาชีพ เพื่อพัฒนาทักษะสำหรับตลาดแรงงาน\n\nและสุดท้าย ในด้านการเมืองการปกครอง ประชาชนจะได้เห็นการจัดทำรัฐธรรมนูญฉบับใหม่ ที่จะแก้ไขจุดด้อยของฉบับที่ผ่านมา ผ่านการทำงานที่โปร่งใสและตรวจสอบได้ ไม่นำไปสู่ความขัดแย้งใหม่ในสังคมไทย\n\nประชาชนจะได้รับการบริการจากภาคราชการที่เร็วขึ้น สะดวกมากขึ้น\nไม่จำเป็นต้องใช้เอกสารกระดาษอีกต่อไป และยังทำให้เชื่อมโยงหลากหลายหน่วยงานเข้าเป็นฐานข้อมูลเดียวกัน มุ่งหน้าไปสู่การเป็น E-government\nที่แท้จริงในอนาคต\n\nประชาชนจะมีส่วนร่วมกับรัฐบาลมากขึ้นผ่านกลไกในระดับชุมชน ซึ่งจะเป็นการสร้างการมีส่วนร่วมของทุกภาคส่วนทั้งภาครัฐ ภาคเอกชน ภาคสังคม ทำให้ประชาชนตื่นตัว และช่วยกันพัฒนาประเทศไปเป็นอันหนึ่งอันเดียวกัน\n\nนโยบายการคลังและความสัมพันธ์ระหว่างรายรับและงบประมาณรายจ่ายที่ขอตั้ง\n\nภายใต้สภาวการณ์ทางเศรษฐกิจดังกล่าว ในปีงบประมาณ พ.ศ.2567 รัฐบาลจึงมีความจำเป็นต้องดำเนินนโยบายงบประมาณขาดดุล เพื่อสนับสนุนการฟื้นตัวของเศรษฐกิจให้มีความต่อเนื่อง\n\nโดยกำหนดรายได้สุทธิ 2,787,000 ล้านบาท และเงินกู้เพื่อชดเชยการขาดดุลงบประมาณ 693,000 ล้านบาท รวมเป็นรายรับ 3,480,000 ล้านบาท เท่ากับวงเงินงบประมาณรายจ่าย\n\nจากการเพิ่มขึ้นของประมาณการรายได้ในปีงบประมาณ พ.ศ.2567 จะทำให้รัฐมีรายได้ 2,787,000 ล้านบาท หรือเพิ่มกว่าร้อยละ 11.9 ทำให้รัฐบาลมีการกู้ชดเชยการขาดดุลงบประมาณลดลงจากปีงบประมาณที่ผ่านมา และสามารถตั้งงบประมาณชำระคืนต้นเงินกู้ การชดใช้เงินคงคลัง และการตั้งงบประมาณ\nรายจ่ายลงทุนที่เพิ่มขึ้นได้\n\n•ฐานะการคลัง\n\nหนี้สาธารณะคงค้าง ณ วันที่ 31 ตุลาคม 2566 มีจำนวน 11,125,428.1 ล้านบาท คิดเป็นร้อยละ 62.1 ของผลิตภัณฑ์มวลรวมในประเทศ ซึ่งอยู่ภายใต้กรอบการบริหารหนี้สาธารณะ ตามกฎหมายว่าด้วยวินัยการเงินการคลังของรัฐ ที่กำหนดไว้ที่ร้อยละ 70 โดยรัฐบาลจะบริหารเงินคงคลังให้อยู่ในระดับที่\nเหมาะสม และบริหารรายรับและรายจ่ายของรัฐให้มีประสิทธิภาพและเกิดประโยชน์สูงสุด\n\n•สาระสำคัญของงบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ.2567\n\nร่างพระราชบัญญัติงบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ.2567 มีวงเงินงบประมาณทั้งสิ้น 3,480,000 ล้านบาท จำแนกเป็นรายจ่ายประจำ 2,532,826.9 ล้านบาท รายจ่ายเพื่อชดใช้เงินคงคลัง 118,361.1 ล้านบาท\n\nรายจ่ายลงทุน 717,722.2 ล้านบาท และรายจ่ายชำระคืนต้นเงินกู้ 118,320.0 ล้านบาท ทั้งนี้รายจ่ายชำระคืนต้นเงินกู้เป็นรายจ่ายลงทุนกรณีการกู้เพื่อการลงทุนของรัฐวิสาหกิจ 7,230.2 ล้านบาท\n\n1.งบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ.2567 จำแนกตามกลุ่มงบประมาณ\n\n1.1 งบประมาณรายจ่ายงบกลาง 606,765.0 ล้านบาท\n\n1.2 งบประมาณรายจ่ายของหน่วยรับงบประมาณ 1,150,144.0 ล้านบาท\n\n1.3 งบประมาณรายจ่ายบูรณาการ 214,601.7 ล้านบาท จำนวน 10 เรื่อง\n\n1.4 งบประมาณรายจ่ายบุคลากร 785,957.6 ล้านบาท\n\n1.5 งบประมาณรายจ่ายสำหรับทุนหมุนเวียน 257,790.5 ล้านบาท\n\n1.6 งบประมาณรายจ่ายเพื่อการชำระหนี้ภาครัฐ 346,380.1 ล้านบาท\n\n1.7 งบประมาณรายจ่ายเพื่อชดใช้เงินคงคลัง 118,361.1 ล้านบาท\n\n2.งบประมาณรายจ่ายประจำปีงบประมาณ พ.ศ.2567 จำแนกตามยุทธศาสตร์การจัดสรรงบประมาณจำนวน 6 ยุทธศาสตร์ 1 รายการสรุปได้ ดังนี้\n\nยุทธศาสตร์ที่ 1 : ด้านความมั่นคง 390,149.3 ล้านบาท\n\nยุทธศาสตร์ที่ 2 : ด้านการสร้างความสามารถในการแข่งขัน 393,517.9 ล้านบาท\n\nยุทธศาสตร์ที่ 3 : ด้านการพัฒนาและเสริมสร้างศักยภาพทรัพยากรมนุษย์ 561,954.2 ล้าน\n\nยุทธศาสตร์ที่ 4 : ด้านการสร้างโอกาสและความเสมอภาคทางสังคม 834,240.6 ล้านบาท\n\nยุทธศาสตร์ที่ 5 : ด้านการสร้างการเติบโตบนคุณภาพชีวิตที่เป็นมิตรต่อสิ่งแวดล้อม 131,292.3 ล้านบาท\n\nยุทธศาสตร์ที่ 6 : ด้านการปรับสมดุลและพัฒนาระบบการบริหารจัดการภาครัฐ 604,804.5 ล้านบาท\n\nและ 1 รายการดำเนินการภาครัฐ\n\nรัฐบาลได้จัดสรรงบประมาณรายจ่ายไว้ 564,041.2 ล้านบาท เพื่อเป็น ค่าใช้จ่ายรองรับเหตุการณ์ที่อาจเกิดขึ้นโดยมิได้คาดหมายสำหรับกรณีฉุกเฉินหรือจำเป็น การบริหารจัดการหนี้ภาครัฐ และชดใช้เงินคงคลัง\n\n•สรุป\n\nงบประมาณรายจ่ายปี พ.ศ.2567 นี้มีงบประมาณรายจ่าย 3,480,000 ล้านบาท โดยจะมีที่มาจากรายได้ที่คาดว่าจะจัดเก็บได้ 2,787,000 ล้านบาท และเป็นการกู้เพื่อชดเชยการขาดดุล 693,000 ล้านบาท\n\nแม้ว่างบประมาณรายจ่ายปีนี้จะเพิ่มขึ้นร้อยละ 9.3 เมื่อเทียบกับปีก่อน แต่รัฐบาลจะสามารถจัดเก็บรายได้ได้มากขึ้นกว่าร้อยละ 11.9  ทำให้สามารถจัดสรรงบไปลงทุนได้กว่า 717,722.2 ล้านบาท ซึ่งเพิ่มขึ้นกว่า ร้อยละ 4.1 และสามารถชดใช้เงินคงคลังและชำระคืนต้นเงินกู้ได้กว่า 118,361.1 ล้านบาท อีกด้วย ซึ่งจะทำเป็นการเตรียมพร้อมทำให้รัฐบาล มีกรอบในการลงทุนในระยะกลางและยาวมากขึ้นในปีงบประมาณ พ.ศ.2568 อีกด้วย\n\nการบริหารงบประมาณรายจ่ายทั้งหมดนี้ จะเป็นจุดเริ่มต้นในการดำเนินนโยบายทั้งในระยะสั้นไปจนถึงระยะยาว โดยรัฐบาลจะดำเนินการให้เป็นไปตามกรอบวินัยการเงินการคลังของรัฐ ใช้จ่ายเงินภาษีของประชาชนอย่างมีประสิทธิภาพมากที่สุด โดยมีเป้าหมายที่จะบำบัดทุกข์ บำรุงสุข ลงทุนเพื่อสร้างการเจริญเติบโตของประเทศทั้งในระยะสั้นและระยะยาว และเป็นไปตามกฎหมาย",
    url: "https://www.matichon.co.th/politics/politics-in-depth/news_4358708",
    platform: "internet",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 0,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "เศรษฐา ทวีสิน,เศรษฐกิจประเทศ,กระทรวงการคลัง",
    created_date: "2024-01-23T08:15:52.000Z",
    updated_date: "2024-01-23T08:15:52.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 518,
    status: 1,
    approved: 1,
    title: "ฝันของนายกทักษิณ ที่ตั้งใจ ทำให้ ประเทศไทย มัก สำเร็จ เสมอ ",
    description:
      "ฝันของนายกทักษิณ ที่ตั้งใจ ทำให้ ประเทศไทย\nมัก สำเร็จ เสมอ \n\nยิ่งถ้า ถ้าคิดว่า\nนายกทักษิณ คิด \nนายกประยุทธ์ ทำ \nนายกเศรษฐา สานต่อ \n\nพวกเรา\nเตรียมตัว ไป นั่งจิบกาแฟ ริม ท่าเทียบเรือที่ ชุมพร/ระนอง \nดูเรือ  Container และ เรือ Cruise ได้เลยค่ะ \n#แลนด์บริดจ์ #Landbridge #LandBridge",
    url: "https://x.com/Sriyadaa/status/1749581318642708854?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 141,
    likes: 303,
    comments: 36,
    views: 17700,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "ประเทศไทย,แลนด์บริดจ์,ทักษิณ ชินวัตร",
    created_date: "2024-01-23T08:14:32.000Z",
    updated_date: "2024-01-23T08:14:32.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 517,
    status: 1,
    approved: 1,
    title: "ฟังจิรายุเช้านี้แล้ว อยากให้จิรายุคนนี้มาด่าจริงๆ",
    description: "ฟังจิรายุเช้านี้แล้ว อยากให้จิรายุคนนี้มาด่าจริงๆ",
    url: "https://www.tiktok.com/@chaiyakritsangsur/video/7326754246630624517?is_from_webapp=1&sender_device=pc&web_id=7142765204576224769",
    platform: "tiktok",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 7,
    comments: 0,
    views: 429,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 1,
    keyword: "จิรายุ ห่วงทรัพย์",
    created_date: "2024-01-23T08:13:44.000Z",
    updated_date: "2024-01-23T08:13:44.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 516,
    status: 1,
    approved: 1,
    title:
      "สอบถามวิธีย้ายค่าย ais ไปทรูหน่อยคะ จำเป็นต้องไปที่สาขามั้ยค่ะ ส่วนตัวใช้ais เน็ตแย่มาก สมัคร1เดือน แต่เน็ตหมดก่อน",
    description:
      "สอบถามวิธีย้ายค่าย ais ไปทรูหน่อยคะ จำเป็นต้องไปที่สาขามั้ยค่ะ ส่วนตัวใช้ais เน็ตแย่มาก สมัคร1เดือน แต่เน็ตหมดก่อน",
    url: "https://pantip.com/topic/42447016",
    platform: "pantip",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 2,
    views: 0,
    negative_trend: 100,
    positive_trend: 0,
    arrow: "in",
    campaign_id: 2,
    keyword: "ย้ายค่าย,สาขาais,เน็ตแย่มาก",
    created_date: "2024-01-23T08:12:45.000Z",
    updated_date: "2024-01-23T08:12:45.000Z",
    campaign_name: "เน็ตAIS",
  },
  {
    id: 515,
    status: 1,
    approved: 1,
    title:
      "เป็นข่าวดีมากเลยสำหรับครูทุกคน รัฐบาลเพื่อไทย ใส่ใจประชาชนจริงๆ อะไรที่เป็นปัญหาก็แก้ไขให้ทันที",
    description:
      "เป็นข่าวดีมากเลยสำหรับครูทุกคน รัฐบาลเพื่อไทย ใส่ใจประชาชนจริงๆ อะไรที่เป็นปัญหาก็แก้ไขให้ทันที",
    url: "https://x.com/ffeebb2233rrdd/status/1749698469395419347?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 6,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "ข่าวดี,รัฐบาลเพื่อไทย,ใส่ใจประชาชน",
    created_date: "2024-01-23T08:09:25.000Z",
    updated_date: "2024-01-23T08:09:25.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 513,
    status: 1,
    approved: 1,
    title:
      "ก้าวไกล เห็นด้วย เพื่อไทย แก้รธน.ทำประชามติ 2 ครั้ง ชี้ต้องโน้มน้าว ส.ว.ให้เห็นชอบ",
    description:
      "ก้าวไกล เห็นด้วย เพื่อไทย แก้รธน.ทำประชามติ 2 ครั้ง ชี้ต้องโน้มน้าว ส.ว.ให้เห็นชอบ",
    url: "https://www.facebook.com/photo/?fbid=801932848645021&set=a.362641849240792",
    platform: "facebook",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 2,
    likes: 91,
    comments: 40,
    views: 0,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "พรรคก้าวไกล,พรรคเพื่อไทย,แก้รธน.,ทำประชามติ",
    created_date: "2024-01-23T08:05:59.000Z",
    updated_date: "2024-01-23T08:05:59.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 512,
    status: 1,
    approved: 1,
    title:
      "กูปักหมุด แคปเก็บไว้  20 ปีมาแล้วมัน ชัดยิ่งกว่าชัด ว่าเสื้อแดง ไทยรักไทย ทักษิณคิดถูกมาตลอดและคือคนที่ต่อ สู้กับเผด็จการ ",
    description:
      "กูปักหมุด แคปเก็บไว้  20 ปีมาแล้วมัน\nชัดยิ่งกว่าชัด ว่าเสื้อแดง ไทยรักไทย\nทักษิณคิดถูกมาตลอดและคือคนที่ต่อ\nสู้กับเผด็จการ อยู่กับประชาธิปไตยมา\nไม่เคยเปลี่ยน จะมีแต่สลิ่มแบบมึงและ\nกองเชียร์ สส.พรรคก้าวไกล ที่เปลี่ยน\nไปมาตามประโยชน์ที่ได้รับ วันนี้ก็ไม่มี\nสถาบันให้โหนละ ก็ล้มซะเลย",
    url: "https://x.com/Tookkae26/status/1749400647668207747?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 11,
    likes: 18,
    comments: 1,
    views: 536,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "เสื้อแดง,ไทยรักไทย,ทักษิณ ชินวัตร,สลิ่ม,พรรคก้าวไกล,เผด็จการ",
    created_date: "2024-01-23T08:05:17.000Z",
    updated_date: "2024-01-23T08:05:17.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 511,
    status: 1,
    approved: 1,
    title:
      "ฝันมาหลายรัฐบาลแล้ว ขอให้นายกนิดทำให้สำเร็จ มร้างประวัติศาสตร์เหมือนสนามบินสุวรรณภูมิ 30บาท ฯลฯ ที่เพื่อไทยทำได้มาตลอด",
    description:
      "ฝันมาหลายรัฐบาลแล้ว ขอให้นายกนิดทำให้สำเร็จ มร้างประวัติศาสตร์เหมือนสนามบินสุวรรณภูมิ 30บาท ฯลฯ ที่เพื่อไทยทำได้มาตลอด",
    url: "https://x.com/lilharree/status/1749618709323559401?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 0,
    comments: 0,
    views: 47,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "รัฐบาล,นายก,ประวัติศาสตร์,30บาท,พรรคเพื่อไทย",
    created_date: "2024-01-23T08:05:00.000Z",
    updated_date: "2024-01-23T08:05:00.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 510,
    status: 1,
    approved: 1,
    title:
      "ส.ว.สุรเดช ยก 4 ปัจจัยหารือที่ประชุม สงสัย ‘แลนด์บริดจ์’ จะสำเร็จไหม แนะ รบ.ฟังรอบด้าน",
    description:
      "ส.ว.สุรเดช ยก 4 ปัจจัยหารือที่ประชุม สงสัย ‘แลนด์บริดจ์’ จะสำเร็จไหม แนะ รบ.ฟังรอบด้าน",
    url: "https://www.facebook.com/photo/?fbid=801934518644854&set=a.362641849240792",
    platform: "facebook",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 0,
    likes: 20,
    comments: 7,
    views: 0,
    negative_trend: 50,
    positive_trend: 50,
    arrow: "in",
    campaign_id: 1,
    keyword: "ส.ว.สุรเดช,แลนด์บริดจ์",
    created_date: "2024-01-23T08:02:53.000Z",
    updated_date: "2024-01-23T08:02:53.000Z",
    campaign_name: "เพื่อไทย",
  },
  {
    id: 508,
    status: 1,
    approved: 1,
    title: "แล้วฝันอันนี้ของคุณทักษิณมันฉุดความเจริญของประเทศยังไงหรอ  ",
    description:
      "แล้วฝันอันนี้ของคุณทักษิณมันฉุดความเจริญของประเทศยังไงหรอ \n\nพอย้อนดูวิสัยทัศน์ของคุณทักษิณปี 56 เรื่อง #แลนด์บริดจ์ คือล้ำมาก\nมองถึงประโยชน์มหาศาลในการใช้ศักยภาพด้านภูมิศาสตร์ของประเทศอย่างเต็มที่\n\nในขณะที่ผ่านมาสิบกว่าปียังมีคนปลุกผีทักษิณมาท่องวนๆไม่เลิก เสียโอกาสอะไรช่างมัน",
    url: "https://x.com/svndw81/status/1749434785439584503?s=20",
    platform: "twitter",
    pinned: 0,
    warned: 0,
    bombed: 0,
    boosted: 0,
    shares: 180,
    likes: 244,
    comments: 41,
    views: 85400,
    negative_trend: 0,
    positive_trend: 100,
    arrow: "in",
    campaign_id: 1,
    keyword: "ทักษิณ ชินวัตร,แลนด์บริดจ์",
    created_date: "2024-01-23T07:59:01.000Z",
    updated_date: "2024-01-23T07:59:01.000Z",
    campaign_name: "เพื่อไทย",
  },
];

export default mockArchive;
